import { Grid, InputLabel } from "@mui/material";
import * as React from "react";
import InputBox from "./InputBox";
import DropDown from "./Dropdowns";
import TimeRanges from "./TimeRanges";
import EditableTextFieldss from "./EditableTextField/EditableTextFieldss";
import Buttons from "./Buttons";
import { priodicityArray, buttonNames, weekDaysArray, priodicityArrayPhase2 } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchingAllCriteria, fetchingSubCriteriaAndOperator, fetchingSubCriteriaOperator } from "../redux/Actions";

export default function AccordianComponent(props) {
  const dispatch = useDispatch();
  var allpack = useSelector((state) => state?.sns);

  const [inputValue, setInputValue] = React.useState(props.packdata.duration);
  const [periodicity, setPeriodicity] = React.useState(
    props.packdata.periodicity
  );
  const [messageText, setMessageText] = React.useState(
    props.packdata.messageText
  );
  const [weekDay, setWeekDay] = React.useState(
    props.packdata.weekDays
  );

  const [tsHours, setTsHours] = React.useState(props.packdata.tsHours);
  const [tsMinutes, setTsMinutes] = React.useState(props.packdata.tsMinutes);
  const [endHours, setEndHours] = React.useState(props.packdata.endHours);
  const [endMinutes, setEndMinutes] = React.useState(props.packdata.endMinutes);
  const [isEnable, setIsEnable] = React.useState(props?.checkboxdata);
  const [startDays, setStartDay] = React.useState(props.packdata.startDays);
  const [payload, setPayload] = React.useState("");
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
  //-----------------------------criteria-----------------
  const [criteriaAndOperator, setCriteriaAndOperator] = React.useState([""]);
  const [operator, setOperator] = React.useState(props.packdata?.operators);

  //------------------------------------------------------

  React.useEffect(() => {
    let body = {
      method: props.packdata.usecaseId.length >= 1 ? "put" : "post",
      usecaseProfileName: props.packdata.usecaseProfileName,
      isEnable: props?.checkboxdata
        ? props?.checkboxdata[props.packdata.usecaseId]
        : props.packdata.isEnable, // props.packdata.isEnable,
      periodicity: periodicity,
      duration: inputValue,
      totalNotification: props.packdata.totalNotification,
      tsHours: tsHours,//endHours
      tsMinutes: tsMinutes,//endMinutes
      endHours: null,//tsMinutes
      endMinutes: null,//tsMinutes
      messageText: messageText, //"Dear user, your Super Plan subscription pack is set to expire on <EXPIRY_DATE>. Kindly recharge your pack to continue enjoying uninterrupted services.",
      landingPoints: props.packdata.landingPoints, //["Point1", "Point2"],
      usecaseDisplayName: props.packdata.usecaseDisplayName, //"Send notification before pack expiry."
      usecaseId: props.packdata.usecaseId,
      startDays: startDays,
      weekDays: weekDay,
      userSegmentCriteria: criteriaAndOperator,
      operators: operator
    };
    setPayload(body);
    setIsButtonDisabled(periodicity === props.packdata.periodicity
      && inputValue === props.packdata.duration &&
      tsHours === props.packdata.tsHours &&
      tsMinutes === props.packdata.tsMinutes &&
      messageText === props.packdata.messageText &&
      startDays === props.packdata.startDays &&
      weekDay === props.packdata.weekDays &&
      criteriaAndOperator);
  }, [
    periodicity,
    inputValue,
    tsHours,
    tsMinutes,
    // endHours,
    // endMinutes,
    messageText,
    startDays,
    weekDay,
    criteriaAndOperator,
    operator
  ]);

  React.useEffect(() => {
    setOperator([])
    setCriteriaAndOperator([''])
    setCriteriaAndOperator(props.packdata?.userSegmentCriteria ? props.packdata?.userSegmentCriteria : [])
    setOperator(props.packdata?.operators ? props.packdata?.operators : [])
    // if(props.packdata.isEnable){
    //   dispatch(fetchingAllCriteria());
    // }
  }, [props.packdata?.operator, props.expanded,props.packdata.isEnable])


  React.useEffect(() => {
    const combinedArray = [];

    if (props.packdata?.userSegmentCriteria && props.packdata?.operators) {
      // Initialize the third array
      // Iterate through the criteria array
      props.packdata?.userSegmentCriteria.forEach((criterion, index) => {
        // Add the criterion to the combined array
        combinedArray.push(criterion);
        // Check if there's an operator corresponding to this criterion
        if (index < props.packdata?.operators.length) {
          // Add the operator to the combined array
          combinedArray.push(props.packdata?.operators[index]);
        }
      });
    }

    if (combinedArray.length > 0 && props.expanded && props.packdata.usecaseProfileName === "NotificationForWatchlistReminder") {
      for (let index = 0; index < combinedArray.length; index++) {
        if (index == 0) {
          handleOpratorAndSubCategory(combinedArray[index], "c1")
        }
        else if (index == 1) {
          handleOprator(combinedArray[index], "op1")
        } else if (index == 2) {
          handleOpratorAndSubCategory(combinedArray[index], "c2")
        } else if (index == 3) {
          handleOprator(combinedArray[index], "op2")
        }

      }

    }


  }, [props?.expanded])


  const insertAtCursor = (myField, myValue) => {
    //IE support
    if (document.selection) {
      myField.focus();
      let sel = document.selection.createRange();
      sel.text = myValue;
    }
    // Microsoft Edge
    else if (window.navigator.userAgent.indexOf("Edge") > -1) {
      var startPos = myField.selectionStart;
      var endPos = myField.selectionEnd;

      myField.value =
        myField.value.substring(0, startPos) +
        myValue +
        myField.value.substring(endPos, myField.value.length);

      var pos = startPos + myValue.length;
      myField.focus();
      myField.setSelectionRange(pos, pos);
      setMessageText(myField.value);
    }
    //MOZILLA and others
    else if (myField.selectionStart || myField.selectionStart == "0") {
      var startPos = myField.selectionStart;
      var endPos = myField.selectionEnd;
      myField.value =
        myField.value.substring(0, startPos) +
        myValue +
        myField.value.substring(endPos, myField.value.length);
      setMessageText(myField.value);
    } else {
      myField.value += myValue;
      setMessageText(myField.value);
    }
  };

  function handleCriteria(e, count) {
    if ((e?.target?.value?.criteria || e?.target?.value || e) != capitalize(splitText(criteriaAndOperator[0]))) {
      setOperator([])
      setCriteriaAndOperator([''])
      setCriteriaAndOperator([e?.target?.value ? e.target.value : e])
      let body = {
        "criteria1": e?.target?.value ? e.target.value : e,
        "criteria_count": count
      }
      dispatch(fetchingSubCriteriaOperator(body));
    }


  }

  function handleOprator(e, count) {
    setOperator([...operator, e?.target?.value ? e.target.value : e])
    let body = {
      "criteria1": count === "op1" ? criteriaAndOperator[0] : criteriaAndOperator[1],
      "operator": e?.target?.value ? e.target.value : e,
      "operator_count": count
    }
    dispatch(fetchingSubCriteriaAndOperator(body));
  }
  function handleOpratorAndSubCategory(e, count) {
    setCriteriaAndOperator([...criteriaAndOperator, e?.target?.value?.criteria ? e.target.value?.criteria : e?.target?.value ? e.target.value : e])
    let body = {
      "criteria1": e?.target?.value?.criteria ? e.target.value?.criteria : e?.target?.value ? e.target.value : e,
      "criteria_count": count
    }
    dispatch(fetchingSubCriteriaOperator(body));
  }

  function splitText(t) { return t != undefined ? t.replace("_", " ") : ""; }
  function capitalize(s) { return s != 0 || s != undefined ? s.toLowerCase().replace(/\b./g, function (a) { return a.toUpperCase() }) : "" };
  
  return (
    <Grid container rowSpacing={3} columnSpacing={{ xs: 2, sm: 2, md: 2 }}>
      {props.packdata.isStartdate && <Grid item xs={3}>
        <InputBox
          label={"Start Day"}
          duration={props.packdata?.startDays}
          onChange={(e) => {
            setStartDay(e.target.value)
          }} />
      </Grid>}
      {props.packdata.isduration && <Grid item xs={3}>
        <InputBox
          label={"Duration"}
          duration={props.packdata?.duration}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Grid>}
      {props.packdata.isperiodicity && <Grid item xs={3}>
        <DropDown
          periodicity={props.packdata?.periodicity}
          weekDays={props.packdata?.weekDays}
          onChange={(e) => setPeriodicity(e.target.value)}
          title={"Periodicity"}
          data={props.packdata.phase === 1 ? priodicityArray : priodicityArrayPhase2}
        />
      </Grid>}

      {periodicity === "SPECIFIC_DAYS" && <Grid item xs={3}>
        <DropDown
          periodicity={props.packdata?.weekDays[0]}
          onChange={(e) => setWeekDay([e.target.value])}
          title={"Select specific day "}
          data={weekDaysArray}
        />
      </Grid>}

      {props.packdata.istime && <Grid item xs={3}>
        <TimeRanges
          tsHours={props.packdata?.tsHours}
          tsMinutes={props.packdata?.tsMinutes}
          endHours={props.packdata?.endHours}
          endMinutes={props.packdata?.endMinutes}
          onChange={(e) => {
            if (e.type == "totime") {
              setTsHours(e.hour);
              setTsMinutes(e.minute);
            } else {
              setEndHours(e.hour);
              setEndMinutes(e.minute);
            }
            //
          }}
        />
      </Grid>}
      {props?.packdata?.isUserSegmentation && <Grid style={{ margin: "0px" }} container rowSpacing={3} columnSpacing={{ xs: 2, sm: 2, md: 2 }}>
       <Grid item xs={3}>
          <DropDown
            // periodicity={props.packdata?.userSegmentCriteria ? capitalize(splitText(criteriaAndOperator[0])) : ""}
            periodicity={props.packdata?.userSegmentCriteria[0] ? criteriaAndOperator[0] : ""}
            onChange={(e) => handleCriteria(e, "c1")}
            title={"Criteria"}
            data={props?.criteria}
          />
        </Grid>
        {(criteriaAndOperator[0] && operator[0]) && <Grid item xs={2}>
          <DropDown
            periodicity={props.packdata?.operators[0] ? props.packdata?.operators[0]  : ""}
            onChange={(e) => handleOprator(e, "op1")}
            title={"Operator"}
            data={allpack?.criteriaOperator?.data?.operator.length>0  ? allpack?.criteriaOperator?.data?.operator : [props.packdata?.operators[0]]}
          />
        </Grid>}
        {operator[0] && allpack?.criteriaAndOperator?.data?.criteria.length > 0 && <Grid item xs={3}>
          <DropDown
            periodicity={props.packdata?.userSegmentCriteria ? criteriaAndOperator[1] : ""}
            onChange={(e) => handleOpratorAndSubCategory(e, "c2")}
            title={"Sub Criteria"}
            data={allpack?.criteriaAndOperator?.data?.criteria ? allpack?.criteriaAndOperator?.data?.criteria : [capitalize(splitText(props.packdata?.userSegmentCriteria[1] ? props.packdata?.userSegmentCriteria[1] : ""))]}
          />
        </Grid>}
        {criteriaAndOperator[1] && allpack?.criteriaOperator2?.data?.operator.length > 0 && <Grid item xs={2}>
          <DropDown
            periodicity={props.packdata?.operators ? operator[1] : ""}
            onChange={(e) => handleOprator(e, "op2")}
            title={"Operator"}
            data={allpack?.criteriaOperator2?.data?.operator ? allpack?.criteriaOperator2?.data?.operator : [props.packdata?.operators[1]]}
          />
        </Grid>}
        {operator[1] && allpack?.criteriaAndOperator2?.data?.criteria.length > 0 && <Grid item xs={3}>
          <DropDown
            periodicity={props.packdata?.userSegmentCriteria ? criteriaAndOperator[2] : ""}
            onChange={(e) => setCriteriaAndOperator([...criteriaAndOperator, e.target.value])}
            title={"Sub Criteria"}
            data={allpack?.criteriaAndOperator2?.data?.criteria ? allpack?.criteriaAndOperator2?.data?.criteria : [capitalize(splitText(props.packdata?.userSegmentCriteria[2] ? props.packdata?.userSegmentCriteria[2] : ""))]}
          />
        </Grid>}
      </Grid>}
      {props.packdata.ismessageBody && <Grid item xl={12}>
        {/* <EditableTextFieldss messageText={props.packdata?.messageText}/> */}
        <InputLabel className='__Input-label textareaTitle' id="label">Message body</InputLabel>
        <textarea className="editable" style={props.packdata.usecaseProfileName === "NotificationForUnloginAccount" ? { paddingTop: "4px" } : { paddingTop: "32px" }} id={props.packdata.usecaseId} onChange={(e) => { setMessageText(e.target.value) }}>
          {props.packdata?.messageText}
        </textarea>
        <div class="tagdiv">
          {props.packdata.tags.rmn &&
            <input
              type="button"
              id="btn"
              onClick={() =>
                insertAtCursor(
                  document.getElementById(props.packdata.usecaseId),
                  buttonNames.rmn
                )
              }
              value="RMN"
            />
          }
          {props.packdata.tags.subscriptionEndDate &&
            <input
              type="button"
              id="btn2"
              onClick={() =>
                insertAtCursor(
                  document.getElementById(props.packdata.usecaseId),
                  buttonNames.subscriptionEndDate
                )
              }
              value="Expiry Date"
            />
          }
          {props.packdata.tags.devicetype &&
            <input
              type="button"
              id="btn3"
              onClick={() =>
                insertAtCursor(
                  document.getElementById(props.packdata.usecaseId),
                  buttonNames.devicetype
                )
              }
              value="Device Type"
            />
          }
          {props.packdata.tags.content_title &&
            <input
              type="button"
              id="btn4"
              onClick={() =>
                insertAtCursor(
                  document.getElementById(props.packdata.usecaseId),
                  buttonNames.content_title
                )
              }
              value="Content Title"
            />
          }
        </div>
      </Grid>}
      <Grid item xsOffset={12} xs={12} className="__buttonleft">
        <Buttons
          name={props.packdata.usecaseId.length >= 1 ? "Update" : "Submit"}
          data={payload}
          type={"accordiasubmit"}
          disabled={isButtonDisabled}
        />
      </Grid>
    </Grid>
  );
}